<template>
  <div class='inline-block absolute-children'>
    <div class="inline-block row" :style='{width: ((size/10) * 2.5) + "rem"}'>
      <div class="grid-6">
        <button
          type="button"
          :style='{width: (size/10) + "rem"}'
          class="primary-green-bg left"
          @click="positiveAction">
          {{ buttonText.accept.text || 'PROCEED' }}
        </button>
      </div>
      <div class="grid-6">
        <button
          type="button"
          :style='{width: (size/10) + "rem"}'
          class="red-bg right"
          @click="negativeAction">
          {{ buttonText.decline.text || 'DECLINE' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getContainerWidthFromText } from '../../../Services/styleHelper'

export default {
  props: {
    'buttonText': {
      required: false
    },
    'value': {
      required: false
    },
    'action': {
      required: false
    }
  },
  methods: {
    positiveAction () {
      if (typeof this.action === 'function') {
        this.action()
      }
      this.$emit('input', true)
    },
    negativeAction () {
      this.$emit('input', false)
    }
  },
  computed: {
    size () {
      return Math.max(
        getContainerWidthFromText(this.buttonText.accept.text || 'APPROVE', '1.3rem', '1.1rem 1.5rem'),
        getContainerWidthFromText(this.buttonText.decline.text || 'DECLINE', '1.3rem', '1.1rem 1.5rem')
      )
    }
  },
  watch: {
    size () {
      console.log(this.size)
    }
  }
}
</script>

<style scoped>
.inline-block {
  display: inline-block;
  position: relative;
  width: 100%;
  text-align: center;
}

.absolute-children > * {
  position: relative;
}

button {
  letter-spacing: .1rem;
  font-size: 1.3rem;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// DualButtons.vue?5f271110